export enum EnumUserRole {
    adminGlobal = 1,
    adminOrga = 2,
    AdminClient = 3,
    offer = 4
}
